import React, { lazy, Suspense } from "react";
import { useAppSelector } from "../../../store/index.ts";
import ShowContainer from "../ShowContainer.jsx";

const ChoseLang = lazy(() => import("./ChoseLang.jsx"));

export default function ChooseLangController() {
  const isTgBot = useAppSelector((state) => state.common.isTgBot);

  return (
    <ShowContainer condition={!isTgBot}>
      <Suspense>
        <ChoseLang />
      </Suspense>
    </ShowContainer>
  );
}
